import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CompareIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.44457 3.81416L1.35156 3.81416M5.22213 10.8516L13.3151 10.8516"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.81496 6.63057L1 3.81561L3.81496 1.00065M10.8524 13.668L13.6673 10.853L10.8524 8.03805"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

CompareIcon.displayName = 'CompareIcon';
